// Type dropdowns are listed alphabetically by name (case-insensitive)
const byName = (a, b) => String(a.name).localeCompare(String(b.name), undefined, { sensitivity: 'base' })

export default {
  getUnitsOfMeasure (state) {
    return state.unitsOfMeasure
  },
  getTypes (state) {
    let combined = state.type.product.concat(state.type.pipe).concat(state.type.fitting).concat(state.type.fixing).concat(state.type.other)
    let sorted = combined.sort(byName)
    return sorted
  },
  getTypePipe (state) {
    return state.type.pipe.slice().sort(byName)
  },
  getTypeFitting (state) {
    return state.type.fitting.slice().sort(byName)
  },
  getTypeFixing (state) {
    return state.type.fixing.slice().sort(byName)
  },
  getQty (state) {
    return state.qty
  },
  getTimeComplete (state) {
    return state.time_complete
  },
  getSize (state) {
    return state.size
  }
}
